module.exports = __webpack_public_path__ + "img/reason-detail.e64b5b5b.png";